<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/child'
import PageHeader from '@components/page-header'

export default {
  page: {
    title: 'Dblogs',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: 'Dblogs',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'Dblogs', to: '/dblogs', },
        { text: '', active: true, },
      ],

      tabIndex: 0,

      loading: true,
      item: [],
      filters: {
        paginate: 1,
        page: 1,
        total: 0,
        getmapping: 'yes',
        wheres: {
          id: this.$route.params.id
        },
      },

    }
  },
  created() {
    this.tabIndex = parseInt(window.location.hash.replace('#',''), 10);
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$http.get('/api/dblogs/fetch', {params: this.filters}).then(res => {
        // console.log(res);
        if(res.data.data.length == 1) {
          this.item = res.data.data[0];
        } else {
          $this.$noty.warning("Content could not be found.");
          this.$router.push('/dblogs');
        }
        this.loading = false;
      }).catch(res => { this.popupErrors(res); this.loading = false; });
    },
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div v-if="item.id">

      <div class="row mt-3">
        <div class="col-sm-3">
          <div class="card-box ribbon-box">

            <h4 class="font-13 text-uppercase">About :</h4>
            <div class="table-responsive">
              <table class="table table-sm table-px-0">
                <tbody>
                  <tr><th class="border-0">Title :</th><td class="border-0">{{item.title}}</td></tr>
                  <tr><th>Tracker ID :</th><td>?id={{item.tracker_id}}</td></tr>
                  <tr><th>Description :</th><td>{{item.description}}</td></tr>
                  <tr><th>Last updated :</th><td v-tippy :content="moment(item.updated_at).format('lll')">{{moment(item.updated_at).fromNow()}}</td></tr>
                  <tr><th>Created on :</th><td v-tippy :content="moment(item.created_at).format('lll')">{{moment(item.created_at).fromNow()}}</td></tr>
                </tbody>
              </table>
            </div>

            <pre>{{item}}</pre>

          </div>
        </div>
        <div class="col-sm-9">
          <div class="card">
            <iframe
              :src="app_url+'dblogs/fetchdisplay?id='+item.id"
              height="1500"
              frameborder="0"
              class="w-100"
            ></iframe>
          </div>
        </div>
        <div class="col-sm-12">

        </div>
      </div>

    </div>
  </Layout>
</template>
